import { useCallback } from 'react';
import { useGlobalContext } from '~/context/vm/GlobalContext';
import fetchGeocode from '~/services/vm/fetchGeocode';
import { generateErrorLogger } from '~/utilities/loggers';

export default function useGetFetchGeocode() {
  const { currentZip, setGeoCoords } = useGlobalContext();

  return useCallback(() => {
    fetchGeocode(currentZip)
      .then(coords => {
        if (!coords) return;
        setGeoCoords({ lat: coords.latitude, lng: coords.longitude });
      })
      .catch(generateErrorLogger('Failed to fetch geocode'));
  }, [currentZip, setGeoCoords]);
}
